import { OnInit } from "@angular/core";
import { Store } from '@ngrx/store';
import { AppState, selectLanguageInCommonState } from 'app/app-state.index';
import { BusinessManagmentService } from "app/core/services/business-managment.service";
import { CouponService } from "app/core/services/coupon.service";
import { LoginService } from "app/login/services/login.service";
import { BusinessLookupDto } from "app/public/model/BusinessManagment";
import { FieldType } from "app/shared/components/ag-grid-dynamic/grid-types";
import { LocalizationService } from "app/shared/localization/localization.service";
import { businessCategory, FieldTypes } from "app/shared/model/enums";
import { CommonService } from "app/shared/services/common.service";
import { BehaviorSubject, map, Observable, Subscription, switchMapTo, tap } from "rxjs";

export abstract class BaseLeadsManagement {
  columns: { field: string; headerTranslate: string; type?: FieldTypes; width?: string;sortable?: boolean }[]
  lids$: Observable<any[]>;
  totalRecords: number;
  returnTotalRecords = false;
  loadLidsEvent$ = new BehaviorSubject(true);
  _startDate: Date;
  _endDate: Date;
  numRowsInPage = 100;
  allCategories;
  subscriptions = new Subscription();
  selectedCategory: { value: any; }
  dateRange: Date[] = [];
  businessCategory = businessCategory;
  request: { Filter: { CreatedAt: { From: Date; To: Date; }; CategoryId: number,BusinessId:number};SortField:string; SortOrder:string; Paging: any; }
  currentLang: any;
  businesses: BusinessLookupDto[] = [];
  filteredBusinesses: BusinessLookupDto[] = [];
  selectedBusiness: BusinessLookupDto | null = null;
  viewLidDetails = false;
  lidId: number;
  lidDetails;
  constructor(public businessManagmentService: BusinessManagmentService, public loginService: LoginService, public store: Store<AppState>, public localizationService: LocalizationService, public commonService: CommonService,) {
    this.subscriptions.add(store.select(selectLanguageInCommonState).subscribe(language => {
      this.currentLang = language;

    }));
  }
  init(): void {
    this.commonService.changeCurrentPageHeader(this.localizationService.Translate('MENU.LEADS_MANAGMENT'));
    this.initColumns()
    this.createRequest()
    this.loadCategories()
    this.loadBusinessNames()
  }
  loadBusinessNames() {
  this.businessManagmentService.getBusinessNames().subscribe(res => {
    this.businesses = res; 
    console.log(this.businesses);
    
  });
}
 onOpenLidDetails(event) {
    this.lidId = event.itemId;
    this.lidDetails = event.selectedRow;
    this.viewLidDetails = true;
  }
onSort(event: any) {
if (event.multisortmeta && event.multisortmeta.length > 0) {
    const sortField = event.multisortmeta[0].field;
    const sortOrder = event.multisortmeta[0].order === 1 ? 'asc' : 'desc';
    this.request.SortField = sortField;
    this.request.SortOrder = sortOrder;

    this.loadLids();
  }
}
filterBusinessNames(event: any) {
  const query = event.query.toLowerCase();
  this.filteredBusinesses = this.businesses.filter(b =>
    b.Name.toLowerCase().includes(query)
  );
}

onBusinessSelected() {
  this.request.Filter.BusinessId = this.selectedBusiness?.Id ?? null;
  this.loadLids();
}

clearBusinessFilter() {
  this.selectedBusiness = null;
  this.request.Filter.BusinessId = null;
  this.loadLids();
}
  loadCategories(): void {
    this.loginService.getCategoriesTypes(this.currentLang).subscribe((res: any) => {
      if (res.Category) {
        this.allCategories = res.Category.map(category => { return { label: category.Description, value: category.Id } });
        const otherCategory = this.allCategories.find(c => c.value == this.businessCategory.other);
        if (otherCategory) {
          this.allCategories = [...this.allCategories.filter(c => c.value != this.businessCategory.other), otherCategory];
        }
      }
    })
  }
  loadLids() {
    if (!this.lids$) {
      this.initLoadLidsObservable();
    } else {
      this.loadLidsEvent$.next(true);
    }
  }
  createRequest(pageNo?: number) {
    this.request = {
      Paging: {
        PageNo: pageNo ? pageNo : 1,
        NumberRowsInPage: this.numRowsInPage
      },
      Filter: {
        CreatedAt: {
          From: this.dateRange[0] || null,
          To: this.dateRange[1] || null,
        },
        CategoryId: null,
        BusinessId:null
      },
      SortField:null,
      SortOrder:null   
    }
    if (pageNo) {
      this.initLoadLidsObservable();
    }
  }
  filterSelectCategory() {
    if (this.selectedCategory) {
      this.request.Filter.CategoryId = this.selectedCategory.value;
    } else {
      this.request.Filter.CategoryId = null;
    }
    this.loadLids()
  }
initLoadLidsObservable() {
  this.lids$ = this.loadLidsEvent$.pipe(
    switchMapTo(
      this.businessManagmentService.getLeads(this.request).pipe(
        tap(res => {
          this.totalRecords = res.TotalCount;
          if (this.totalRecords)
            this.returnTotalRecords = true;
        }),
        map(res => {
          return res.Lids.map(lid => {
            lid.Source = this.getSource(lid.Source);
            return lid;
          });
        })
      )
    )
  );
}
  filterCreatedDate() {
    this.request.Filter.CreatedAt = {
      From: this.dateRange?.[0] ?? null,
      To: this.dateRange?.[1] ?? null
    };
    this.loadLids();
  }
  private getSource (source: number): string{
  let sourceName=""
  switch (source) {
     case 2:
      sourceName='BUSINESS_MANAGEMENT.WEB';
      break;
      default:
      sourceName= 'BUSINESS_MANAGEMENT.FRONTALY';
  }
  return this.localizationService.Translate(sourceName);
}
  private initColumns() {
    this.columns = [
      {
        field: 'BusinessName',
        headerTranslate: 'LEADS_MANAGMENT.BUSINESS_NAME',
        sortable:true
      },
      {
        field:"Source",
        headerTranslate:"LEADS_MANAGMENT.SOURCE",
        sortable:false

      },
      {
        field: 'FirstWinCreatedDate',
        headerTranslate: 'CUSTOMERS.FIRST_WINS_CREATED_DATE',
        type: FieldTypes.fullDate,
        sortable:true

      },
      {
        field: 'FirstName',
        headerTranslate: 'CUSTOMERS.FIRST_NAME',
                sortable:true

      },
      {
        field: 'LastName',
        headerTranslate: 'CUSTOMERS.LAST_NAME',
                sortable:true

      },
      {
        field: 'Phone',
        headerTranslate: 'CUSTOMERS.PHONE',
        sortable:false

      },
      {
        field: 'Email',
        width: '10%',
        headerTranslate: 'CUSTOMERS.EMAIL',
        sortable:false

      },
      {
        field: 'Address',
        width: '20%',
        headerTranslate: 'CUSTOMERS.ADDRESS',
                sortable:false

      },
      {
        field: 'OpenWinsCount',
        headerTranslate: 'CUSTOMERS.OPEN_WINS_COUNT',
        sortable:true

      },
      {
        field: 'RedeemedWinsCount',
        headerTranslate: 'CUSTOMERS.REDEEMED_WINS_COUNT',
        sortable:true

      },
      {
        field: 'ExpiredWinsCount',
        headerTranslate: 'CUSTOMERS.EXPIRED_WINS_COUNT',
        sortable:true

      }

    ]
  }



}